import React, { useState, useEffect } from "react";
import { Container, Row } from "reactstrap";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import DataReactTable from "@/containers/Tables/DataTable/components/DataReactTable";
import AddModal from "@/shared/components/AddModal";
import Modal from "@/shared/components/Modal";
import {
  useLazyGetRecordsQuery,
  useDeleteMutation,
} from "@/services/pcApi";
import { ENTITY_TAG } from "@/shared/tagFile";
import { successToast } from "@/shared/components/toast";
import { formateColumnFilter } from "@/utils/columnFilter";
import EntityForm from "./EntityForm";
import { getAllEntity } from "../../OrgSlice";
import "react-toastify/dist/ReactToastify.css";

const Entity = () => {
  const [entityDetails, setEntityDetails] = useState();
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const [deleteEntity, { isLoading: isDeleting }] = useDeleteMutation();
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState([]);
  const [globalSearchKeyword, setGlobalSearchKeyword] = useState(null);
  const [columnFilter, setColumnFilter] = useState({});
  const dispatch = useDispatch();
  const [
    getEntityRecords,
    {
      data: entityList,
      isError: isEntityError,
      isLoading: isEntityLoading,
      isFetching: isEntityFetching,
    },
  ] = useLazyGetRecordsQuery();

  const column = [
    {
      Header: "#",
      accessor: "Id",
      type: "Number",
    },
    {
      Header: "Name",
      accessor: "Name",
      filter: true,
    },
    {
      Header: "Description",
      accessor: "Description",
      filter: true,
      Cell: ({ value }) => {
        return value ? value : "-";
      },
    },
    {
      Header: "Entity Type",
      accessor: "EntityTypeDTO.Name",
      filter: true,
    },
    {
      Header: "Sort Order",
      accessor: "SortOrder",
      type: "Number",
      Cell: ({ value }) => {
        return value ? value : "-";
      },
    },
  ];

  const handleEditData = (entityData) => {
    setSelectedRecord(entityData);
    setIsAddModalOpen(true);
  };

  const handleDelete = () => {
    deleteEntity({
      entity: "Org/Entity",
      id: selectedRecord.Id,
      tag: ENTITY_TAG,
    }).then((response) => {
      if (!response.error) {
        !isDeleting && setIsDeleteModalOpen(!isDeleteModalOpen);
        successToast("Entity deleted successfully.");
      }
    });
  };

  useEffect(() => {
    let { filterColumn, filterQuery } = formateColumnFilter(
      column,
      columnFilter
    );
    getEntityRecords({
      entity: "Org/Entities",
      entities: { EntityType: {} },
      top: pageSize,
      skip: (page - 1) * pageSize,
      sort: sort,
      filter: filterQuery,
      globalFilter: {
        columns: filterColumn,
        globalSearchKeyword: globalSearchKeyword,
      },
      tag: ENTITY_TAG,
    });
    setEntityDetails({ tableHeaderData: column, tableRowsData: [] });
    // eslint-disable-next-line
  }, [pageSize, page, sort, globalSearchKeyword, columnFilter]);

  useEffect(() => {
    if (!isEntityLoading && !isEntityError && entityList && !isEntityFetching) {
      dispatch(getAllEntity(entityList.value));
      let entityData = [...entityList.value];
      setEntityDetails({
        ...entityDetails,
        tableRowsData: entityList.value ? entityData : [],
        totalData:
          entityList && entityList["@odata.count"]
            ? entityList["@odata.count"]
            : 0,
        onEditClick: (data) => handleEditData(data),
        onDeleteClick: (data) => {
          setIsDeleteModalOpen(true);
          setSelectedRecord(data);
        },
      });
    }
    // eslint-disable-next-line
  }, [isEntityError, entityList, isEntityLoading, isEntityFetching]);

  const deleteMessage = () => {
    return (
      <div>
        Are you sure you want to delete {selectedRecord?.Name}?
        <div className="warning-div">
          <i>
            This will delete all the associated records <br />
            ( Like - Users, EntityRelation, EntityResponses, Roles, Contacts, UserLocations, UserRelationRequests etc)
          </i>
        </div>
      </div>
    );
  }

  return (
    <Container>
      <Row>
        {entityDetails && (
          <DataReactTable
            reactTableData={entityDetails}
            onAddClick={() => {
              setIsAddModalOpen(true);
              setSelectedRecord();
            }}
            buttonText={"Wizard"}
            title="Entity"
            isFetching={isEntityFetching}
            setPageNumber={setPage}
            recordsPerPage={pageSize}
            setRecordsPerPage={setPageSize}
            setSort={setSort}
            setGlobalSearchKeyword={setGlobalSearchKeyword}
            setColumnFilter={setColumnFilter}
          />
        )}
      </Row>
      {isAddModalOpen && (
        <AddModal
          toggle={() => setIsAddModalOpen(!isAddModalOpen)}
          color="success"
          title={`${selectedRecord ? "Edit" : "Add"} Entity`}
          header
          btn="Success"
          message={
            <EntityForm
              setIsAddModalOpen={setIsAddModalOpen}
              editData={selectedRecord ? selectedRecord : {}}
            />
          }
        />
      )}
      {isDeleteModalOpen && (
        <Modal
          color="danger"
          title="Delete"
          message={deleteMessage()}
          handleOkClick={() => handleDelete()}
          toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}
          isDeleting={isDeleting}
        />
      )}
    </Container>
  );
};

export default Entity;
